import moment from 'moment';
import { fetchPresignedUrl } from './fetchPresignedUrl';

export const generateMetadataTemplate = (
  startTime,
  startLat,
  startLon,
  endTime,
  endLat,
  endLon,
  end
) =>
  `Start Time: ${moment(startTime).format(
    'MM/DD/YYYY hh:mm a'
  )}\nStart Latitude: ${startLat}\nStart Longitude: ${startLon}\n${
    end
      ? `End Time: ${moment(endTime).format(
          'MM/DD/YYYY hh:mm a'
        )}\nEnd Latitude: ${endLat}\nEnd Longitude: ${endLon}`
      : ''
  }`;

export const getBinaryContentFromPresignedLinks = async (photoArray, setPhotoCounter, token) => {
  let counter = 0;

  return await Promise.all(
    photoArray.map(({ original, thumbnail, filename, ...rest }) => {
      return new Promise(resolve => {
        fetchPresignedUrl([original, thumbnail], token).then(src =>
          Promise.all([fetch(src[0]), fetch(src[1])])
            .then(r => {
              return r;
            })
            .then(binaryContent => {
              counter += 1;
              setPhotoCounter(counter);
              resolve([
                {
                  binaryContent: binaryContent[0],
                  filename: filename,
                  ...rest,
                },
                {
                  binaryContent: binaryContent[1],
                  filename: 'thumb_' + filename,
                  ...rest,
                },
              ]);
            })
        );
      });
    })
  );
};

export const generateFilesFromBinaryContent = (
  imgDataArray,
  imgFolder,
  setDownloading,
  setPhotoCounter
) => {
  imgDataArray.forEach(binaryContent => {
    for (let i = 0; i < binaryContent.length; i++) {
      const bin = binaryContent[i];
      if (!!bin && bin.binaryContent.status !== 404) {
        imgFolder.file(`${bin.filename}`, bin.binaryContent.blob(), {
          binary: true,
        });
      }
    }
  });

  setPhotoCounter(0);
  setDownloading(false);
};
